import { useEffect, useState } from 'react';
import BuildInfo from '@Services/BuildInfo';

export const useBuildInfo = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    BuildInfo.getBuildInfo().then((buildData) => setData(buildData));
  }, []);
  return data;
};

export default useBuildInfo;
